import { FaListAlt } from "react-icons/fa";
import { FaCar } from "react-icons/fa";
import { MdPayments } from "react-icons/md";
import { GoSettings } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function NavigationBar() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState("General");

  const selectHandler = (item) => {
    setSelected(item);
    navigate(`/${item.toLowerCase()}`);
  };
  return (
    <div className="grid items-center grid-cols-4 p-4 justify-items-center rounded-b-xl md:hidden bg-stone-900">
      <div
        className="transition-transform duration-200 active:scale-90"
        onClick={() => selectHandler("General")}
      >
        <FaListAlt
          className={`w-6 h-6 ${
            selected === "General" ? "text-yellow-600" : "text-stone-400"
          }`}
        />
      </div>

      <div
        className="transition-transform duration-200 active:scale-90"
        onClick={() => selectHandler("Vehicles")}
      >
        <FaCar
          className={`w-6 h-6 ${
            selected === "Vehicles" ? "text-yellow-600" : "text-stone-400"
          }`}
        />
      </div>
      <div
        className="transition-transform duration-200 active:scale-90"
        onClick={() => selectHandler("payments")}
      >
        <MdPayments
          className={`w-6 h-6 ${
            selected === "Settings" ? "text-yellow-600" : "text-stone-400"
          }`}
        />
      </div>
      <div
        className="transition-transform duration-200 active:scale-90"
        onClick={() => selectHandler("Settings")}
      >
        <GoSettings
          className={`w-6 h-6 ${
            selected === "Settings" ? "text-yellow-600" : "text-stone-400"
          }`}
        />
      </div>
    </div>
  );
}
